import { debounce } from "lodash-es";
import React from "react";
import { useLatest, useUpdateEffect } from "react-use";
export const useDebouncedValue = (value, ms = 500, settings) => {
    const [state, setState] = React.useState(value);
    const valueLatest = useLatest(value);
    const update = React.useRef(debounce(() => {
        setState(valueLatest.current);
    }, ms, settings));
    useUpdateEffect(() => {
        update.current();
    }, [value]);
    return state;
};
//# sourceMappingURL=useDebouncedValue.js.map